const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMmEyIDIgMCAwIDEgMiAydjEyYTIgMiAwIDAgMS0yIDJoLTcuOTEzTDYgMjEuODA0VjE4SDRhMiAyIDAgMCAxLTItMlY0YTIgMiAwIDAgMSAyLTJoMTZ6bTAgMkg0djEyaDR2Mi4xOTZMMTEuNTEzIDE2SDIwVjR6bS03IDJ2M2gzdjJoLTN2M2gtMnYtM0g4VjloM1Y2aDJ6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  M as default
};
//# sourceMappingURL=add_comment-87e91c3d.mjs.map
